import { isAnalyticsEnabled } from '../core/lib';
import { PendoAccount, PendoVisitor, SonarPendoWindow } from './@types';

declare const window: SonarPendoWindow;

function isPendoAnalyticsEnabled(): boolean {
	// eslint-disable-next-line camelcase
	const { pendo_api_key } = window.sonar;

	// eslint-disable-next-line camelcase
	return Boolean(pendo_api_key) && isAnalyticsEnabled();
}

export function initializePendo(account: PendoAccount, visitor: PendoVisitor): void {
	if (window.pendo?.initialize && isPendoAnalyticsEnabled()) {
		const { initialize } = window.pendo;

		initialize({
			account,
			visitor
		});
	}
}
